<template>
  <div v-if="lot">
    <label class="form-control-label">
      <h4>Lot Name</h4>
    </label>
    <input
      ref="name"
      type="text"
      v-model="name"
      maxlength="255"
      @change="update"
      :disabled="!canEdit"
      class="form-control"
    />
    <nameValidation :$v="$v" />
  </div>
</template>

<script>
import { prizeService } from "@/api/client";
import nameValidation from "@/views/prize/lot/validation/name.vue";
import { FormEditValidateRule as validateRules } from "@/views/prize/lot/validation";

export default {
  props: ["lot"],

  components: {
    nameValidation,
  },

  validations: { name: validateRules.name },

  data() {
    return {
      id: null,
      name: null,
    };
  },

  computed: {
    canEdit() {
      return ["draft"].includes(this.lot.status);
    },
  },

  mounted() {
    this.id = this.lot.id;
    this.name = this.lot.lot_name;
  },

  methods: {
    async isFormValid() {
      if (this.$v.name.$invalid) {
        await this.$dialogs.alert("กรุณากรอก Lot Name ให้ถูกต้อง");
        this.$refs.name.focus();
        return false;
      }
      return true;
    },

    async update() {
      try {
        const formValid = await this.isFormValid();
        if (!formValid) return;

        await prizeService.updateLot(this.lot.id, {
          lot_name: this.name,
        });
        this.$notify(`Lot name updated.`);
        this.$emit("updated");
      } catch (error) {
        error.response
          ? this.$dialogs.alert(error.response.data)
          : this.$dialogs.alert(`Upload Lot name error.`);
      }
    },
  },
};
</script>

<style></style>
